import * as types from './types'

export const setSelectedPlan = (selectedPlan: string) => ({
  type: types.SET_SELECTED_PLAN,
  selectedPlan
})
export const setFieldText = (fieldName: string, text: string | boolean) => ({
  type: types.SET_FIELD_TEXT,
  fieldName,
  text
})
export const activateAccount = () => ({
  type: types.ACTIVATE_ACCOUNT
})
export const activateAccountSent = () => ({
  type: types.ACTIVATE_ACCOUNT_SENT
})
export const activateAccountSuccess = () => ({
  type: types.ACTIVATE_ACCOUNT_SUCCESS
})
export const activateAccountFailed = () => ({
  type: types.ACTIVATE_ACCOUNT_FAILED
})
export const activateInternalAccount = () => ({
  type: types.ACTIVATE_ACCOUNT_INTERNAL
})
export const activateInternalAccountSent = () => ({
  type: types.ACTIVATE_INTERNAL_ACCOUNT_SENT
})
export const activateInternalAccountSuccess = () => ({
  type: types.ACTIVATE_INTERNAL_ACCOUNT_SUCCESS
})
export const activateInternalAccountFailed = () => ({
  type: types.ACTIVATE_INTERNAL_ACCOUNT_FAILED
})
export const updateAccountActivation = () => ({
  type: types.UPDATE_ACCOUNT_ACTIVATION
})
export const updateAccountActivationSuccess = () => ({
  type: types.UPDATE_ACCOUNT_ACTIVATION_SUCCESS
})
export const updateAccountActivationFailed = () => ({
  type: types.UPDATE_ACCOUNT_ACTIVATION_FAILED
})
export const reset = () => ({
  type: types.RESET_ACTIVATE_ACCOUNT_FORM
})
export const setLoading = (isLoading: boolean) => ({
  type: types.SET_ACTIVATE_LOADING_SPINNER,
  isLoading
})
export const setChangeCardMode = (isChangeCardMode: boolean) => ({
  type: types.SET_CHANGE_CARD_MODE,
  isChangeCardMode
})
